<div class="logo">
  <img src="/assets/logos/logo-full-white-iso@128.png" height="50px">
  <a [href]="url" class="link" target="_self" *ngIf="showManualRedirection">
    Tap here to redirect
  </a>
</div>
